module.exports = __webpack_public_path__ + "static/media/PackTrackVid.7619ba3d.mov";